import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => mergeStyleSets({
  advanced: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '8px',
    gap: '10px',
    '& .timestamp-field': {
      marginTop: '8px',
    },
  },
});
